// extracted by mini-css-extract-plugin
module.exports = {"text":"LiveInvite_text__1_67g","caption":"LiveInvite_caption__1RF22","wrapper":"LiveInvite_wrapper__3MOcy","container":"LiveInvite_container__cTCAI","dot":"LiveInvite_dot__3EPzV"};